import { listMessages, searchMessages } from '../../services/globalChatMessages'

// Adapts the Global Search message service to the generic chat-engine `api` shape
// (listPage/search), mirroring searchroomChatApi so the transcript/search engine
// pieces are reused as-is.
export function makeGlobalChatApi(chatId) {
  return {
    listPage: (opts) => listMessages(chatId, opts),
    search: ({ q, limit }) => searchMessages(chatId, q, limit),
  }
}
